export enum ResetPasswordDataCySelector {
    RESET_PASSWORD_FORM = 'reset-password-form'
}
